import styled from 'styled-components'

const EmailAttachments = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`

export default EmailAttachments